import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowLeftIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  ArrowPathIcon,
  CloudArrowUpIcon,
  PlayIcon,
} from '@heroicons/react/24/outline';

const EditorToolbar = ({
  playbookId,
  playbookName,
  isDirty,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onAutoLayout,
  onPublish,
  publishing,
  onTestRun,
  testRunning,
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
      <div className="flex items-center gap-4">
        <Link
          to={`/playbooks/playbook/${playbookId}`}
          className="inline-flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 transition-colors"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Back
        </Link>

        <div className="h-5 w-px bg-gray-300 dark:bg-gray-600" />

        <div className="flex items-center gap-1">
          <span className="text-sm font-semibold text-gray-900 dark:text-white truncate max-w-[300px]">
            {playbookName}
          </span>
          {isDirty && (
            <span className="w-2 h-2 rounded-full bg-amber-500 ml-1" title="Unsaved changes" />
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={onUndo}
          disabled={!canUndo}
          className="p-2 rounded-md text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          title="Undo (Ctrl+Z)"
        >
          <ArrowUturnLeftIcon className="w-4 h-4" />
        </button>
        <button
          onClick={onRedo}
          disabled={!canRedo}
          className="p-2 rounded-md text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          title="Redo (Ctrl+Y)"
        >
          <ArrowUturnRightIcon className="w-4 h-4" />
        </button>

        <div className="h-5 w-px bg-gray-300 dark:bg-gray-600 mx-1" />

        <button
          onClick={onAutoLayout}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
          title="Auto-arrange nodes"
        >
          <ArrowPathIcon className="w-4 h-4" />
          Auto Layout
        </button>

        <div className="h-5 w-px bg-gray-300 dark:bg-gray-600 mx-1" />

        <button
          onClick={onTestRun}
          disabled={testRunning}
          className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-md disabled:bg-emerald-400 disabled:cursor-not-allowed transition-colors"
          title="Test run the current workflow"
        >
          <PlayIcon className="w-4 h-4" />
          {testRunning ? 'Running...' : 'Test Run'}
        </button>

        <button
          onClick={onPublish}
          disabled={!isDirty || publishing}
          className="inline-flex items-center gap-2 px-4 py-2 bg-violet-700 hover:bg-violet-800 text-white text-sm font-medium rounded-md disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          <CloudArrowUpIcon className="w-4 h-4" />
          {publishing ? 'Publishing...' : 'Publish'}
        </button>
      </div>
    </div>
  );
};

export default EditorToolbar;
